import api from './api';

export const finishWatchingIntroVideo = () => api.put('/users/intro-video');

export const verifyRefCode = (code) => api.post(`/reference-code/verify?code=${code}`);
